/**
 * Drop your audio files into: public/sounds/ludo/
 *
 * Required:
 *   dice-click.mp3  — plays when you tap the dice
 *
 * Optional — set to null to skip:
 *   dice-tick.mp3   — while the dice is rolling
 *   dice-land.mp3   — when the final face shows
 *   token-die.mp3   — when an opponent captures your token
 *   Safe-place.mp3  — when any token lands on a star / safe square
 *   Moving-Token.mp3 — on each cell while a token is moving
 *   Dice-Winning.mp3 — when a token reaches the home / winning zone
 *
 * Change the filename or extension to match your download (e.g. dice-click.wav)
 */
export const LUDO_SOUND_FILES = {
  click: 'dice-click.mp3',
  tick: null,
  land: null,
  tokenDie: 'token-die.mp3',
  safePlace: 'Safe-place.mp3',
  movingToken: 'Moving-Token.mp3',
  diceWinning: 'Dice-Winning.mp3',
};

export const LUDO_SOUND_VOLUME = {
  click: 1,
  tick: 0.75,
  land: 1,
  tokenDie: 1,
  safePlace: 1,
  movingToken: 0.85,
  diceWinning: 1,
};

/** Max playback length per sound (ms) — trims long MP3 files */
export const LUDO_SOUND_MAX_MS = {
  click: 1000,
  tick: 120,
  land: 1000,
  tokenDie: 1000,
  safePlace: 1500,
  movingToken: 400,
  diceWinning: 3500,
};
